export function getDisplayModeQuery() {
  const query = window.matchMedia('(display-mode: standalone), (display-mode: minimal-ui)');
  return { query };
}
